import { select, call, put } from 'redux-saga/effects';
import { get } from 'lodash';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;

export function* deleteShareLayer(action) {
  const serverConfig = yield select(getServerConfig);
  const layerId = get(action, 'payload.layerId');
  const userIds = get(action, 'payload.userIds');

  if (userIds.length) {
    for (let i = 0; i < userIds.length; i += 1) {
      const path = `/layer/${serverConfig.namespace}/share/${layerId}/${userIds[i]}`;
      yield call(API, 'del', 'api', path);
    }
  }

  yield put({
    type: 'REMOVE_USERS_FROM_LAYER',
    payload: {
      layerId,
      userIds,
    },
  });
}
